import { forwardRef } from 'react';

// Renderizado fora da tela e capturado como imagem — proporção 9:16
const OracleShareCard = forwardRef(function OracleShareCard({ frase, area }, ref) {
  return (
    <div ref={ref} className="oracle-share-card">
      {/* Blobs decorativos */}
      <div className="oracle-share-blob oracle-share-blob-1" />
      <div className="oracle-share-blob oracle-share-blob-2" />
      <div className="oracle-share-blob oracle-share-blob-3" />

      {/* Header — logo + instagram */}
      <div className="oracle-share-header">
        <div className="oracle-share-header-left">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#7b5ea7">
            <path d="M12 2 L13.8 10.2 L22 12 L13.8 13.8 L12 22 L10.2 13.8 L2 12 L10.2 10.2 Z"/>
          </svg>
          <span className="oracle-share-logo-text">Clube do Eu</span>
        </div>
        <div className="oracle-share-instagram">
          {/* Ícone Instagram */}
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="rgba(47,43,95,0.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
            <circle cx="12" cy="12" r="4"/>
            <circle cx="17.5" cy="6.5" r="0.5" fill="rgba(47,43,95,0.4)" stroke="none"/>
          </svg>
          <span className="oracle-share-ig-handle">@oclubedoeu</span>
        </div>
      </div>

      {/* Corpo central */}
      <div className="oracle-share-body">
        {/* Separador top */}
        <div className="oracle-share-divider" />

        {/* Tag de área */}
        {area && (
          <p className="oracle-share-area">{area.label.toUpperCase()}</p>
        )}

        {/* Separador bottom */}
        <div className="oracle-share-divider" />

        {/* Quote */}
        <blockquote className="oracle-share-frase">
          "{frase}"
        </blockquote>

        {/* Estrela decorativa */}
        <div className="oracle-share-star">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="#7b5ea7" opacity="0.25">
            <path d="M12 2 L13.8 10.2 L22 12 L13.8 13.8 L12 22 L10.2 13.8 L2 12 L10.2 10.2 Z"/>
          </svg>
        </div>
      </div>

      {/* Footer */}
      <div className="oracle-share-footer">
        <p className="oracle-share-handle">oclubedoeu.com.br</p>
      </div>
    </div>
  );
});

export default OracleShareCard;
